import React from 'react';

import { getCaptionsFromConfig } from 'components/VideoTemplateEditor/state';
import { getBaseCaptionsOverride } from 'utils/embed/captions/utils';
import { useTemplateDispatch } from '../context/VideoTemplateDispatchContext';
import { CaptionsState } from '../types';

interface UseCaptionsDefaultStyleConfig {
  aspectRatio: number;
  isFullEpisode: boolean;
  /** Optional existing captions config to use instead of computing new defaults. */
  currentCaptionsConfig?: CaptionsState;
}

const useCaptionsDefaultStyle = (
  config: UseCaptionsDefaultStyleConfig,
): void => {
  const { aspectRatio, isFullEpisode, currentCaptionsConfig } = config;

  // Leaving the prev value as undefined to ensure at least it will be run once
  // even if isFullEpisode is set just once over the life cycle
  const [prevIsFullEpisode, setPrevIsFullEpisode] = React.useState<
    boolean | undefined
  >(undefined);

  const dispatch = useTemplateDispatch();

  if (prevIsFullEpisode !== isFullEpisode) {
    setPrevIsFullEpisode(isFullEpisode);

    dispatch({
      type: 'CAPTIONS_CONFIG_UPDATE',
      payload: {
        captions:
          currentCaptionsConfig ??
          getCaptionsFromConfig(
            getBaseCaptionsOverride(aspectRatio, isFullEpisode),
          ),
      },
    });
  }
};

export default useCaptionsDefaultStyle;
